import SearchBusinesses from "components/global/SearchBusinesses";

const VCSearchBusinesses = () => <SearchBusinesses />;

export default VCSearchBusinesses;